import { getSeries, downsampleSeriesBy, normalizeSeries } from '@/utils/chart-data'
import { pipe } from '@/utils/pipe'

const series = pipe(getSeries, downsampleSeriesBy('speed'), normalizeSeries)

export const chartSeries = state => {
  if (state.track.points) {
    return series(state.track.points)
  }
}

export const currentPoint = state => {
  return state.track.points && state.track.points[state.track.current_idx] || {}
}

export const currentDistance = state => {
  return state.track.distances && state.track.distances[state.track.current_idx]
}

export const currentReadout = (state, getters) => {
  const point = getters.currentPoint
  return {
    speed: point.v_kmh,
    elevation: point.ele,
    distance: getters.currentDistance
  }
}

export const currentPercent = (state) => {
  return state.track.points && (state.track.current_idx * 100) / (state.track.points.length - 1)
}



// WEBPACK FOOTER //
// ./src/store/getters.js